import type { RefOrGetter } from "ls/common/types";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { STALE } from "ls/queries/staleTime";
import { computed, toValue } from "vue";
import { EmptyGuid } from "@/common/lib";
import { queries } from "./queries";

export function useOrganization(organizationId: RefOrGetter<string | undefined>) {
  const queryClient = useQueryClient();
  const options = computed(() => {
    const orgId = toValue(organizationId);

    return {
      ...queries.info(toValue(orgId)),
      placeholderData: () => {
        const queryKey = queries.list().queryKey;
        return queryClient.getQueryData(queryKey)?.find(d => d.Id === toValue(organizationId));
      },
      enabled: !!orgId && orgId !== EmptyGuid,
      staleTime: STALE.SECONDS.FIFTEEN,
    };
  });

  const query = useQuery(options);
  return query.data;
}

export function useOrganizationFromList(organizationId: RefOrGetter<string>) {
  const options = computed(() => {
    return {
      ...queries.list(),
      staleTime: STALE.INFINITY,
    };
  });

  const query = useQuery(options);
  const organization = computed(() => query.data.value?.find(org => org.Id === toValue(organizationId)));

  return organization;
}
